<script setup lang="ts">
import { computed } from 'vue'
import { useProgramEnrollments } from '@/composables/eos/program-enrollments'
import type { IISOEnergyProgram } from '@/types/eos/ProgramEnrollment'

const model = defineModel<IISOEnergyProgram | undefined>()

const props = defineProps<{ disabled?: boolean }>()

const { isoEnergyProgramsQuery } = useProgramEnrollments()
const { data: isoEnergyPrograms } = isoEnergyProgramsQuery()

const groupedPrograms = computed(() => {
  // @ts-expect-error - Object.groupBy is not typed
  const byType: Record<string, IISOEnergyProgram[]> = Object.groupBy(
    isoEnergyPrograms.value ?? [],
    (p: IISOEnergyProgram) => p.type
  )
  return Object.entries(byType).map(([label, options]) => ({ label, options }))
})
</script>

<template>
  <el-select v-model="model" value-key="id" :disabled="props.disabled">
    <el-option-group v-for="group in groupedPrograms" :key="group.label" :label="group.label">
      <el-option v-for="item in group.options" :key="item.id" :label="item.name" :value="item" />
    </el-option-group>
  </el-select>
</template>
